import { TenantEntity } from '../TenantEntity'
import { queryStatusByBusinessDataId, saveStatusChangeHistory } from '@/api/seaExport/statusChangeHistory'

export class StatusChangeHistory extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get statusType() {
    return this._data.statusType
  }
  set statusType(statusType) {
    this._data.statusType = statusType || 0
  }
  get statusValue() {
    return this._data.statusValue
  }
  set statusValue(statusValue) {
    this._data.statusValue = statusValue
  }
  get businessDataId() {
    return this._data.businessDataId
  }
  set businessDataId(businessDataId) {
    this._data.businessDataId = businessDataId
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  static async queryStatusByBusinessDataId(cargoDocUuid) {
    return await queryStatusByBusinessDataId({ cargoDocUuid }).then(res => res.data)
  }
  async save() {
    await saveStatusChangeHistory(this._data)
  }
}
